/* BLACK DUST MOTOR CO. — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Header: scrolled state ---------- */
  var header = $('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Smart sticky header (mobile / tablet): hide on scroll down, show on scroll up ---------- */
  var headerEl = $('.header');
  var headerWrap = headerEl ? (headerEl.closest('.shopify-section') || headerEl.parentElement) : null;
  if (headerWrap) headerWrap.classList.add('header-wrap');
  if (headerWrap) {
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY, dy = y - lastY;
        var locked = (drawer && drawer.classList.contains('is-open')) || (searchDrop && searchDrop.classList.contains('is-open'));
        if (y < 80 || dy < -4 || locked) headerWrap.classList.remove('is-hidden');
        else if (dy > 6) headerWrap.classList.add('is-hidden');
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Mobile drawer ---------- */
  var drawer = $('#drawer');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var c = $('[data-drawer-close]', drawer); if (c) c.focus(); }
  }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  window.matchMedia('(min-width: 1240px)').addEventListener('change', function (e) { if (e.matches) setDrawer(false); });

  /* ---------- Search drop ---------- */
  var searchDrop = $('#search-drop');
  $$('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!searchDrop) { window.location.href = '/search'; return; }
      var open = !searchDrop.classList.contains('is-open');
      searchDrop.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = $('input[type="search"]', searchDrop); if (i) i.focus(); }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setDrawer(false);
    if (searchDrop) searchDrop.classList.remove('is-open');
  });

  /* ---------- Reveal on scroll ---------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Money + cart count ---------- */
  function money(cents) {
    var f = (window.bd && window.bd.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return withComma + '.' + parts[1];
        case 'amount_no_decimals': return withComma;
        case 'amount_with_comma_separator': return parts[0] + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return parts[0];
        default: return withComma + '.' + parts[1];
      }
    });
  }
  window.bdMoney = money;

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-empty', n < 1 ? 'true' : 'false');
    });
  }

  /* ---------- Toast ---------- */
  var toast;
  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span>' + msg + '</span><span class="toast__links"><a href="' + (window.bd ? window.bd.cartUrl : '/cart') + '">View cart</a><a class="btn" href="/checkout">Checkout</a></span>';
    requestAnimationFrame(function () { toast.classList.add('is-show'); });
    clearTimeout(showToast.t);
    showToast.t = setTimeout(function () { toast.classList.remove('is-show'); }, 4200);
  }

  /* ---------- Quantity steppers ---------- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    $$('[data-qty-step]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var min = parseInt(input.getAttribute('min') || '0', 10);
        var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Product page ---------- */
  var pdp = $('[data-product]');
  if (pdp) {
    var data = JSON.parse($('[data-product-json]', pdp).textContent);
    var form = $('form[data-ajax-cart]', pdp);
    var idInput = $('input[name="id"]', form);
    var addBtn = $('[data-add]', form);
    var priceEl = $('[data-price]', pdp);
    var track = $('[data-gallery-track]', pdp);
    var thumbs = $$('[data-thumb]', pdp);

    var goToSlide = function (i) {
      if (!track) return;
      var slide = $$('[data-slide]', track)[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goToSlide(i); });
    });
    if (track && thumbs.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }, { passive: true });
    }

    var selectedOptions = function () {
      return $$('.opt', pdp).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    };
    var findVariant = function (opts) {
      return data.variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    };
    var renderPrice = function (v) {
      if (!priceEl) return;
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html = '<span class="price price--sale"><ins>' + money(v.price) + '</ins> <s>' + money(v.compare_at_price) + '</s></span>';
      } else {
        html = '<span class="price">' + money(v.price) + '</span>';
      }
      priceEl.innerHTML = html;
    };
    var onVariant = function () {
      var opts = selectedOptions();
      $$('.opt', pdp).forEach(function (fs, i) {
        var s = $('[data-opt-selected]', fs);
        if (s) s.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      renderPrice(v);
      var sb = $('[data-add-sticky]');
      if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      var sp = $('[data-buybar-price]');
      if (sp) sp.textContent = money(v.price);
      var note = $('[data-soldout-note]');
      if (note) note.hidden = v.available;
      if (v.featured_media && v.featured_media.id) {
        var idx = $$('[data-slide]', pdp).findIndex(function (s) { return s.getAttribute('data-media-id') == v.featured_media.id; });
        if (idx > -1) goToSlide(idx);
      }
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    };
    $$('.opt input', pdp).forEach(function (r) { r.addEventListener('change', onVariant); });
  }

  /* ---------- Sticky buy bar (mobile product page) ---------- */
  var buybar = $('[data-buybar]');
  var buyAnchor = $('[data-add]', pdp || document);
  if (buybar && buyAnchor && 'IntersectionObserver' in window) {
    document.body.classList.add('has-buybar');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { buybar.classList.toggle('is-show', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(buyAnchor);
  }

  /* ---------- AJAX add to cart ---------- */
  $$('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.bd) return;
      e.preventDefault();
      var btn = $('[data-add]', form);
      var sticky = form.id === 'product-form' ? $('[data-add-sticky]') : null;
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      if (sticky) { sticky.disabled = true; sticky.textContent = 'Adding…'; }
      fetch(window.bd.cartAddUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.body.description || res.body.message || 'Could not add to cart'); }
          return fetch(window.bd.cartJsUrl).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCount(cart.item_count);
          showToast('Added to cart');
          if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1600); }
          if (sticky) { sticky.textContent = 'Added ✓'; setTimeout(function () { sticky.disabled = false; sticky.textContent = 'Add to cart'; }, 1600); }
        })
        .catch(function (err) {
          showToast(err.message);
          if (btn) { btn.disabled = false; btn.textContent = original; }
          if (sticky) { sticky.disabled = false; sticky.textContent = 'Add to cart'; }
        });
    });
  });

  /* ---------- Collection sort ---------- */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  /* ---------- Cart page: auto-update on qty change ---------- */
  $$('[data-cart-form] [data-qty] input').forEach(function (i) {
    i.addEventListener('change', function () { i.form.submit(); });
  });
})();
